var React = require('react');

function BlueArrow (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M64.4793 49.7587L103.155 86.0588C104.492 87.3137 106.66 87.3137 107.997 86.0588C109.334 84.8035 109.334 82.7688 107.997 81.5137L66.9006 42.9411C65.5633 41.6863 63.3953 41.6863 62.0581 42.9411L20.9613 81.5137C19.6473 82.7907 19.6851 84.8255 21.0456 86.0588C22.3728 87.2617 24.4768 87.2617 25.8038 86.0588L64.4793 49.7587Z","fill":"#5186EE"}));
}

BlueArrow.defaultProps = {"width":"128","height":"128","viewBox":"0 0 128 128","fill":"none"};

module.exports = BlueArrow;

BlueArrow.default = BlueArrow;
